const updateHeaderInterceptor = (axiosInstance: any, token: string) => {
    axiosInstance.interceptors.request.use((config: any) => {
        config.headers["Stone-Token"] = token
        return config;
    });
};
export default updateHeaderInterceptor;
